import React, { forwardRef, useEffect, useState } from 'react';
import './tokenx-form.scss';
import useTokenxForm from './useTokenXForm';
var TokenxForm = forwardRef(function TokenxForm(props, ref) {
  var _useTokenxForm = useTokenxForm(props, ref),
      onExpiryChange = _useTokenxForm.onExpiryChange,
      creditCardMessage = _useTokenxForm.creditCardMessage,
      cvvMessage = _useTokenxForm.cvvMessage,
      expiryMessage = _useTokenxForm.expiryMessage,
      expiry = _useTokenxForm.expiry;

  var renderError = function renderError(msg) {
    return msg ? /*#__PURE__*/React.createElement("div", {
      className: "tokenx-form__error"
    }, /*#__PURE__*/React.createElement("svg", {
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0",
      viewBox: "0 0 512 512",
      height: "1em",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm52.7 283.3L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3l52.7-52.7-52.7-52.7c-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3 6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6-6.2 6.3-16.4 6.3-22.6 0z"
    })), msg) : null;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "tokenx-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tokenx-form__input-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    id: "card-element",
    className: "w-100 tokenx-form__input"
  }), renderError(creditCardMessage)), /*#__PURE__*/React.createElement("div", {
    className: "tokenx-form__input-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    name: "expdate",
    className: "w-100 tokenx-form__input tokenx-form__input--native ".concat(expiryMessage ? 'tokenx-form__input--error' : ''),
    maxLength: 5,
    minLength: 3,
    pattern: "^(0[1-9]|1[0-2])\\/?([0-9]{2})$",
    placeholder: "MM/YY",
    onChange: onExpiryChange,
    value: expiry.length == 2 ? "".concat(expiry, "/") : expiry
  }), renderError(expiryMessage)), /*#__PURE__*/React.createElement("div", {
    className: "tokenx-form__input-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    id: "cvv-element",
    className: "w-100 tokenx-form__input"
  }), renderError(cvvMessage)));
});
export default TokenxForm;